module.exports = __webpack_public_path__ + "img/plum.0804117f.jpeg";